import { getCookie } from 'stash/utils/cookies';
import { SET_GLOBAL_THEME } from 'stash/actions';
import { isDev } from 'stash/utils';
import { DEFAULT_THEME, DEV_THEME_PICKER_COOKIE } from 'stash/constants';

export const initThemeState = {
	name: (isDev() && getCookie(DEV_THEME_PICKER_COOKIE)) || DEFAULT_THEME,
};

export const theme = (state = initThemeState, action) => {
	switch (action.type) {
		case SET_GLOBAL_THEME:
			return {
				...state,
				name: action.name,
			};
		default:
			return state;
	}
};

export default theme;
